import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import CopilotDocumentsAPI from '../../api/copilot/documents';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  records: [],
  meta: {
    currentPage: 1,
    totalEntries: 0,
  },
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getRecords(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  async get({ commit }, params = {}) {
    commit(types.default.SET_COPILOT_DOCUMENTS_UI_FLAG, { fetchingList: true });
    try {
      const response = await CopilotDocumentsAPI.get(params);
      const payload = response.data?.payload || response.data?.documents || [];
      const meta = response.data?.meta || response.data?.meta_attributes || {};
      commit(types.default.SET_COPILOT_DOCUMENTS, payload);
      commit(types.default.SET_COPILOT_DOCUMENTS_META, {
        currentPage: meta.page || meta.current_page || 1,
        totalEntries: meta.total_count || meta.total_entries || payload.length,
      });
      commit(types.default.SET_COPILOT_DOCUMENTS_UI_FLAG, {
        fetchingList: false,
      });
      return payload;
    } catch (error) {
      commit(types.default.SET_COPILOT_DOCUMENTS_UI_FLAG, {
        fetchingList: false,
      });
      return throwErrorMessage(error);
    }
  },

  async create({ commit }, payload) {
    commit(types.default.SET_COPILOT_DOCUMENTS_UI_FLAG, { creatingItem: true });
    try {
      const response = await CopilotDocumentsAPI.create(payload);
      const record = response.data?.payload || response.data;
      if (record) {
        commit(types.default.ADD_COPILOT_DOCUMENTS, record);
      }
      return record;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_COPILOT_DOCUMENTS_UI_FLAG, {
        creatingItem: false,
      });
    }
  },

  async delete({ commit }, id) {
    commit(types.default.SET_COPILOT_DOCUMENTS_UI_FLAG, { deletingItem: true });
    try {
      await CopilotDocumentsAPI.delete(id);
      commit(types.default.DELETE_COPILOT_DOCUMENTS, id);
      return true;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_COPILOT_DOCUMENTS_UI_FLAG, {
        deletingItem: false,
      });
    }
  },
};

const mutations = {
  [types.default.SET_COPILOT_DOCUMENTS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_COPILOT_DOCUMENTS]: MutationHelpers.set,
  [types.default.ADD_COPILOT_DOCUMENTS]: MutationHelpers.create,
  [types.default.DELETE_COPILOT_DOCUMENTS]: MutationHelpers.destroy,
  [types.default.SET_COPILOT_DOCUMENTS_META](_state, data) {
    _state.meta = {
      ..._state.meta,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
